'use strict';

function formSecondStep(offerID, leadID, context) {

  return new Promise(function (resolve, reject) {

    var formOffer = $('#form-offer-' + offerID);
    var formSecondStep = formOffer.find('.form-offer-second');
    var cityElement = formSecondStep.find('.city');
    var cpfCnpjElement = formSecondStep.find('.cpfcnpj');
    var cepElement = formSecondStep.find('.cep');

    formOffer.find('.progress-bar').attr('aria-valuenow', 90).css('width', '90%');
    formOffer.find('.step-count').text('Passo 2');

    formValidateConfig(formSecondStep);

    validatorCep();
    maskCep(cepElement);

    validatorCpfCnpj();
    maskCpfCnpj(cpfCnpjElement);

    loadCityByCep(cepElement, cityElement);
    loadDealershipByCity(cityElement);

    formSecondStep.submit(function (event) {
      event.preventDefault();

      var form = $(this),
          cpfcnpj = form.find('.cpfcnpj').val(),
          cep = form.find('.cep').val(),
          dealership = form.find('.dealerships input:checked').val(),
          message = form.find('.message').val(),
          corporateName = form.find('.corporateName').val(),
          pergunta_validacao = form.find('#pergunta_de_validacao').val(),
          oferta = offerID,
          button = form.find('button[type="submit"]'),
          validation = true,
          lgpd = [];

      form.find(".jc-opt-in").each(function () {
        if ($(this).prop('checked')) {
          lgpd.push([$(this).attr('name'), $(this).parents(".form-group").text().trim(), $(this).parents(".form-group").find('a') ? $(this).parents(".form-group").find('a').map(function () {
            return $(this).attr('href');
          }).get() : null]);
        }
      });

      if (cpfcnpj.length == 18 && corporateName == "") {
        populateAndShowFormError(formOffer, ["Razão social obrigatória em caso de Pessoa Jurídica"]);
        validation = false;
      }

      if (form.valid() && validation) {

        var buttonLabel = button.text();
        button.prop('disabled', true).html('<i class="fa fa-cog fa-spin fa-fw"></i> Enviando...');

        grecaptcha.enterprise.ready(function () {
          grecaptcha.enterprise.execute(ajaxHandler.siteKey, { action: 'save_lead' }).then(function (grecaptchaToken) {

            $.ajax({
              url: ajaxHandler.url_leads + '/api/jornaldocarro/v1/receive-callback/second-step',
              type: 'POST',
              data: {
                action: 'jc_ajax_offer_save_lead_second_step',
                context: context,
                cpfcnpj: cpfcnpj,
                corporateName: corporateName,
                cep: cep,
                dealership: dealership,
                message: message,
                oferta: oferta,
                leadID: leadID,
                pergunta_validacao: pergunta_validacao,
                url_page: window.location.href,
                lgpd: encodeURIComponent(JSON.stringify(lgpd)),
                token: grecaptchaToken
              },
              success: function success(response) {
                if (response && response.success) {
                  var _leadID = response.data.leadID;
                  setLeadIdSessionStorage(_leadID);
                  send_offer_lead_success_events(offerID, _leadID, 'Oferta').then(function () {
                    resolve(_leadID);
                  });
                } else {
                  send_offer_lead_error_events();
                  populateAndShowFormError(formOffer, response.data);
                  button.prop('disabled', false).html(buttonLabel);
                }
              },
              error: function error(data) {
                send_offer_lead_error_events();
                showFormError(formOffer);
                button.prop('disabled', false).html(buttonLabel);
              }
            });
          });
        });
      }
    });
  });
}